<template>
  <nav class="absolute top-0 left-0 right-0 bg-white flex justify-between items-center p-3 opacity-0 transition-opacity duration-300 z-10" :class="{'opacity-100': game}">
    <div class="flex items-center gap-x-4 md:gap-x-6">
      <img :src="`${BaseUrl}/img/icons/menu.svg`" alt="Menu" class="md:hidden w-6 h-6 cursor-pointer" @click="navbarCollapsed = !navbarCollapsed" />
      <div v-if="race" class="flex flex-col gap-x-1">
        <span class="flex items-center text-sm md:text-base font-bold gap-x-1">
          <img :src="`${BaseUrl}/img/icons/marker-start.svg`" alt="Start Marker" width="16" />
          {{ race.start }}
        </span>
        <span class="flex items-center text-sm md:text-base font-bold gap-x-1">
          <img :src="`${BaseUrl}/img/icons/marker-end.svg`" alt="End Marker" width="16" />
          {{ race.end }}
        </span>
      </div>

      <div class="relative hidden md:block group h-8 md:h-10">
        <button @click="$emit('toggleSettings')">
          <img :src="`${BaseUrl}/img/icons/settings.png`" alt="Settings" class="w-8 h-8 md:w-10 md:h-10 group-hover:scale-[1.2] transition-transform duration-300" />
        </button>
        <div class="absolute top-full left-1/2 transform translate-y-2 -translate-x-1/2 px-2 py-1 text-base text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
          Settings
        </div>
      </div>

      <!--<div class="relative group h-10">
        <button @click="$emit('togglePassport')">
          <img :src="`${BaseUrl}/img/icons/passport.png`" alt="Passport" class="w-10 h-10 group-hover:scale-[1.2] transition-transform duration-300" />
        </button>
        <div class="absolute top-full left-1/2 transform translate-y-2 -translate-x-1/2 px-2 py-1 text-base text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
          Passport
        </div>
      </div>

      <div class="relative group h-10">
        <button @click="$emit('toggleJobs')">
          <img :src="`${BaseUrl}/img/icons/work.png`" alt="Jobs" class="w-10 h-10 group-hover:scale-[1.2] transition-transform duration-300" />
        </button>
        <div class="absolute top-full left-1/2 transform translate-y-2 -translate-x-1/2 px-2 py-1 text-base text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
          Jobs
        </div>
      </div>

      <div class="relative group h-10">
        <button @click="$emit('toggleWallet')" class="flex items-center gap-x-3">
          <img :src="`${BaseUrl}/img/icons/wallet.png`" alt="Wallet" class="w-10 h-10 group-hover:scale-[1.2] transition-transform duration-300" />
        </button>
        <div class="absolute top-full left-1/2 transform translate-y-2 -translate-x-1/2 px-2 py-1 text-base text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
          Wallet
        </div>
      </div>-->

      <span class="hidden md:inline text-xl font-bold text-green-400">{{ totalMoney }}</span>

      <div class="hidden md:block relative flex items-center space-x-2">
        <label for="speed" class="text-sm">Speed:</label>
        <select id="speed" v-model="gameSpeed" @change="gameSpeedTipVisible = false" class="bg-gray-800 text-white rounded px-2 py-1 text-sm">
          <option v-for="speed in speedOptions" :key="speed" :value="speed">{{ speed }}x</option>
        </select>
        <div v-if="journeyCount === 1 && gameSpeedTipVisible" class="absolute top-8 left-12 w-56 !m-0 p-2 text-sm bg-white border rounded-lg">
          <span class="font-bold">☝️ Tip:</span> You can adjust the game speed here.  Useful for long journeys
        </div>
      </div>
    </div>

    <div class="flex items-center gap-x-3">
      <div class="hidden md:block flex items-center space-x-2">
        <label for="centerMarker" class="text-sm">Center on player:</label>
        <input id="centerMarker" type="checkbox" v-model="model" class="text-white bg-gray-800 rounded" />
      </div>
      <a href="https://x.com/chrispattle" target="_blank" class="hidden md:flex items-center gap-x-2 bg-black text-white text-sm px-3 py-3 rounded-lg hover:bg-gray-900 transition">
        <img :src="`${BaseUrl}/img/x-logo.svg`" alt="X logo" class="w-5 h-5" />
        <span>Made by @pattle</span>
      </a>
      <a href="https://www.buymeacoffee.com/pattle" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/v2/arial-yellow.png" alt="Buy Me A Coffee" class="h-[34px] w-[124px] md:h-[43px] md:w-[155px]" ></a>
      <!--<Button
        v-if="user.id"
        :loading="saving"
        class="bg-blue-500 text-white text-sm px-2 py-1 rounded hover:bg-blue-600 transition"
        @click="$emit('saveGame')"
      >
        Save
      </Button>-->
    </div>

    <div class="absolute -top-2 md:-top-4 left-1/2 flex flex-col items-center justify-center w-24 h-24 md:w-32 md:h-32 bg-white rounded-full -translate-x-1/2">
      <span class="mt-3 text-xl md:text-3xl font-bold leading-none">{{ formattedTime }}</span>
      <span class="text-sm">{{ dayOfWeek }}</span>
      <hr class="w-1/2 my-1 border-t-2 border-gray-200" />
      <span class="text-sm md:text-base">Day <span class="font-bold">{{ daysPassed + 1 }}</span></span>
    </div>
  </nav>
  <nav class="md:hidden absolute bottom-0 left-0 right-0 bg-white flex justify-between items-center px-3 py-2 opacity-0 transition-opacity duration-300 z-10" :class="{'opacity-100': game}">
    <div class="flex flex-col justify-center items-center gap-1.5">
      <span class="text-xl font-bold text-green-400">{{ totalMoney }}</span>
      <span class="text-sm">Money</span>
    </div>

    <div class="relative flex flex-col justify-center items-center gap-1.5">
      <select id="mobile-speed" v-model="gameSpeed" @change="gameSpeedTipVisible = false" class="bg-gray-800 text-white rounded px-2 py-1 text-sm">
        <option v-for="speed in speedOptions" :key="speed" :value="speed">{{ speed }}x</option>
      </select>
      <label for="mobile-speed" class="text-sm">Speed</label>
      <div v-if="journeyCount === 1 && gameSpeedTipVisible" class="absolute -top-24 left-1/2 w-56 !m-0 p-2 text-sm bg-white border rounded-lg -translate-x-1/2">
        <span class="font-bold">👇 Tip:</span> You can adjust the game speed here.  Useful for long journeys
      </div>
    </div>
    <div class="flex flex-col justify-center items-center gap-1.5">
      <input id="mobile-centerMarker" type="checkbox" v-model="model" class="text-white bg-gray-800 rounded" />
      <label for="mobile-centerMarker" class="text-sm">Center on player</label>
    </div>
  </nav>
  <div class="fixed top-0 left-0 bottom-0 h-dvh w-[90vw] bg-white transition-transform -translate-x-full z-[100]" :class="{'!translate-x-0': !navbarCollapsed}">
    <header class="flex justify-between items-center p-4 border-b border-gray-200">
      <h2 class="text-xl font-bold">Menu</h2>
      <button @click="navbarCollapsed = true">
        <img :src="`${BaseUrl}/img/icons/menu.svg`" alt="Close Menu" class="w-6 h-6" />
      </button>
    </header>
    <div class="p-4">
      <GameSettings
          v-model="showSettingsDialog"
          :initialSettings="gameSettings"
          @updateSettings="updateGameSettings"
      />

      <Button
          class="w-full py-2 text-white font-bold bg-red-500 hover:bg-red-600 rounded"
          style="text-shadow: 0.1rem 0.1rem rgba(0, 0, 0, 0.2)"
          @click="$emit('resetGame')"
      >
          Give up
      </Button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import Button from '@/components/Button.vue';
import GameSettings from '@/components/GameSettings.vue';
import { useGameStore } from '@/stores/useGameStore.js';

const emit = defineEmits(['toggleSettings', 'togglePassport', 'toggleJobs', 'toggleWallet', 'saveGame', 'resetGame', 'update:centerOnMarker']);

const props = defineProps({
  state: Object,
  centerOnMarker: Boolean,
  speedOptions: Array,
  saving: Boolean,
  daysPassed: Number,
  dayOfWeek: String,
});

const BaseUrl = ref(baseUrl);

const gameStore = useGameStore();

const { user, race, game, money, gameTime, timeZoneOffset, gameSpeed, journeyCount, showSettingsDialog, gameSettings } = storeToRefs(gameStore);

const navbarCollapsed = ref(true);

const gameSpeedTipVisible = ref(true);

const model = computed({
  get: () => props.centerOnMarker,
  set: (val) => emit('update:centerOnMarker', val),
});

const formattedTime = computed(() => {
  const _gameTime = gameTime.value + timeZoneOffset.value;
  const hours = Math.floor(_gameTime / 3600) % 24;
  const minutes = Math.floor(_gameTime / 60) % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
});

const totalMoney = computed(() => {
  // Return individual currency values e.g "£100, $50, €30".  If there are more than 3 currencies, return "£100, $50, €30, ...".
  const _money = money.value.map(m => `${m.symbol}${m.value.toFixed(2)}`).join(', ');
  return _money.length > 50 ? `${_money.slice(0, 50)}...` : _money;

  /*return money.reduce((acc, curr) => {
    return acc + `${curr.symbol}${curr.value}/ `;
  }, '').slice(0, -2); // Remove trailing comma and space*/
});

function updateGameSettings(newSettings) {
  gameStore.updateGameSettings(newSettings);
}
</script>
